import { render, staticRenderFns } from "./IncludeExamAfterTransferred.vue?vue&type=template&id=37259efe"
import script from "./IncludeExamAfterTransferred.vue?vue&type=script&lang=js"
export * from "./IncludeExamAfterTransferred.vue?vue&type=script&lang=js"
import style0 from "./IncludeExamAfterTransferred.vue?vue&type=style&index=0&id=37259efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports